import React from "react";
import { Provider } from "react-redux";
import { legacy_createStore as createStore } from "redux";
import { ThemeProvider } from "styled-components";
import Layout from "./src/components/Layout";
import theme from "./src/styles/theme";
const isBrowser = typeof window !== "undefined";

const prefersDarkMode = () => {
  if (isBrowser && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
  return false;
};

const savedTheme = isBrowser ? localStorage.getItem("theme") : null;

const initialThemeState = {
  theme: savedTheme || (prefersDarkMode() ? "dark" : "light"),
};

const themeReducer = (state = initialThemeState, action) => {
  switch (action.type) {
    case "CHANGETHEME":
      return { ...state, theme: action.theme };

    default:
      return state;
  }
};

const store = createStore(themeReducer);

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Layout>{element}</Layout>
      </Provider>
    </ThemeProvider>
  );
};
